// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "money-DHk3Z";
var _3 = "amount-2Orzz";
var _4 = "currency_before-c1n_N";
var _5 = "money_loading-2Cn7W";
var _6 = "currency_after-3XzVG";
var _7 = "money_strikethrough-1oxyP";
export { _1 as "__esModule", _2 as "money", _3 as "amount", _4 as "currency_before", _5 as "money_loading", _6 as "currency_after", _7 as "money_strikethrough" }
export default { "__esModule": _1, "money": _2, "amount": _3, "currency_before": _4, "money_loading": _5, "currency_after": _6, "money_strikethrough": _7 }
